// A2 - Ünite 4: Comparatives & Superlatives
// Hedef: Karşılaştırma, en üstünlük dereceleri

export const A2_UNIT_4 = {
  'A2-U4-L1': {
    id: 'A2-U4-L1',
    title: 'Comparatives (-er / more)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Karşılaştırma (Comparative)',
          explanation: 'İki şeyi karşılaştırmak için sıfatın karşılaştırma formu kullanılır.',
          table: {
            headers: ['Kural', 'Sıfat', 'Comparative', 'Örnek'],
            rows: [
              ['Kısa (1 hece): +er', 'fast', 'faster', 'This plane is faster.'],
              ['Kısa + e: +r', 'large', 'larger', 'The cabin is larger.'],
              ['Kısa + CVC: çift ünsüz + er', 'big', 'bigger', 'This seat is bigger.'],
              ['y ile biten: y→ier', 'easy', 'easier', 'This route is easier.'],
              ['Uzun (2+ hece): more +', 'comfortable', 'more comfortable', 'This seat is more comfortable.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Karşılaştırmaları',
          table: {
            headers: ['Karşılaştırma', 'Türkçesi'],
            rows: [
              ['Business class is more expensive than economy.', 'Business class ekonomiden daha pahalı.'],
              ['The A380 is bigger than the A320.', 'A380, A320\'den daha büyük.'],
              ['This flight is shorter than the previous one.', 'Bu uçuş öncekinden daha kısa.'],
              ['Safety is more important than speed.', 'Güvenlik hızdan daha önemli.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Karşılaştırmada "than" kullanılır: bigger THAN, more comfortable THAN'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'This aircraft is _____ than that one. (big)',
          options: ['bigger', 'more big', 'biger', 'biggest'],
          correct: 'bigger',
          explanation: 'Kısa sıfat + CVC: g çiftlenir + er'
        },
        {
          type: 'multipleChoice',
          question: 'Business class is _____ than economy. (comfortable)',
          options: ['more comfortable', 'comfortabler', 'most comfortable', 'comfortable'],
          correct: 'more comfortable',
          explanation: 'Uzun sıfat: more + sıfat'
        },
        {
          type: 'fillInBlank',
          sentence: 'This flight is _____ (short) than the morning flight.',
          answer: 'shorter',
          hint: 'Kısa sıfat: short + er'
        },
        {
          type: 'matching',
          instruction: 'Sıfatları karşılaştırma formlarıyla eşleştirin',
          pairs: [
            { left: 'fast', right: 'faster' },
            { left: 'big', right: 'bigger' },
            { left: 'easy', right: 'easier' },
            { left: 'expensive', right: 'more expensive' }
          ]
        }
      ]
    }
  },
  'A2-U4-L2': {
    id: 'A2-U4-L2',
    title: 'Superlatives (-est / most)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 En Üstünlük (Superlative)',
          explanation: 'Bir grup içinde en üstün olanı belirtmek için superlative kullanılır.',
          table: {
            headers: ['Kural', 'Sıfat', 'Superlative', 'Örnek'],
            rows: [
              ['Kısa: the + sıfat + est', 'fast', 'the fastest', 'This is the fastest plane.'],
              ['Kısa + CVC: çift + est', 'big', 'the biggest', 'It\'s the biggest airport.'],
              ['y ile biten: y→iest', 'easy', 'the easiest', 'This is the easiest route.'],
              ['Uzun: the most +', 'comfortable', 'the most comfortable', 'This is the most comfortable seat.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Superlative Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['Emirates is one of the best airlines.', 'Emirates en iyi havayollarından biri.'],
              ['This is the longest flight I\'ve worked.', 'Çalıştığım en uzun uçuş bu.'],
              ['Safety is the most important thing.', 'Güvenlik en önemli şey.'],
              ['Heathrow is the busiest airport in Europe.', 'Heathrow, Avrupa\'nın en yoğun havalimanı.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Superlative her zaman "THE" ile kullanılır: THE biggest, THE most important'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'This is _____ airport in the country. (busy)',
          options: ['the busiest', 'the most busy', 'busiest', 'the busyest'],
          correct: 'the busiest',
          explanation: 'y ile biten: y→iest'
        },
        {
          type: 'multipleChoice',
          question: 'Safety is _____ thing in aviation.',
          options: ['the most important', 'the importantest', 'most important', 'the more important'],
          correct: 'the most important',
          explanation: 'Uzun sıfat: the most + sıfat'
        },
        {
          type: 'fillInBlank',
          sentence: 'This is _____ (long) flight to Australia.',
          answer: 'the longest',
          hint: 'Kısa sıfat: the + sıfat + est'
        }
      ]
    }
  },
  'A2-U4-L3': {
    id: 'A2-U4-L3',
    title: 'Irregular Comparatives (good, bad)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Düzensiz Karşılaştırmalar',
          explanation: 'Bazı sıfatların karşılaştırma formları düzensizdir:',
          table: {
            headers: ['Sıfat', 'Comparative', 'Superlative', 'Türkçesi'],
            rows: [
              ['good', 'better', 'the best', 'iyi - daha iyi - en iyi'],
              ['bad', 'worse', 'the worst', 'kötü - daha kötü - en kötü'],
              ['far', 'farther/further', 'the farthest/furthest', 'uzak - daha uzak - en uzak'],
              ['much/many', 'more', 'the most', 'çok - daha çok - en çok'],
              ['little', 'less', 'the least', 'az - daha az - en az']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['This airline is better than that one.', 'Bu havayolu diğerinden daha iyi.'],
              ['The weather is worse today.', 'Hava bugün daha kötü.'],
              ['We need more crew members.', 'Daha fazla ekip üyesine ihtiyacımız var.'],
              ['This is the best service I\'ve experienced.', 'Yaşadığım en iyi hizmet bu.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 good → better → best | bad → worse → worst - Bunları ezberleyin!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'This airline is _____ than the other one. (good)',
          options: ['better', 'gooder', 'more good', 'best'],
          correct: 'better',
          explanation: 'good → better (düzensiz)'
        },
        {
          type: 'multipleChoice',
          question: 'The weather is _____ today. (bad)',
          options: ['worse', 'badder', 'more bad', 'worst'],
          correct: 'worse',
          explanation: 'bad → worse (düzensiz)'
        },
        {
          type: 'fillInBlank',
          sentence: 'This is _____ (good) airline in the world.',
          answer: 'the best',
          hint: 'good → best (superlative)'
        },
        {
          type: 'matching',
          instruction: 'Düzensiz formları eşleştirin',
          pairs: [
            { left: 'good', right: 'better - best' },
            { left: 'bad', right: 'worse - worst' },
            { left: 'far', right: 'farther - farthest' },
            { left: 'much', right: 'more - most' }
          ]
        }
      ]
    }
  },
  'A2-U4-L4': {
    id: 'A2-U4-L4',
    title: 'As...as (Eşitlik)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 As...as - Eşitlik Karşılaştırması',
          explanation: 'İki şeyin eşit olduğunu ifade etmek için "as + sıfat + as" kullanılır.',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['as + sıfat + as', 'This plane is as fast as that one.', 'Bu uçak diğeri kadar hızlı.'],
              ['not as + sıfat + as', 'Economy is not as comfortable as business.', 'Ekonomi, business kadar rahat değil.'],
              ['as + zarf + as', 'She works as hard as him.', 'O, onun kadar çok çalışıyor.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Anlam'],
            rows: [
              ['Safety is as important as service.', 'Eşit önem'],
              ['This route is not as long as the other.', 'Daha kısa'],
              ['She is as experienced as the purser.', 'Eşit deneyim'],
              ['The delay was not as bad as expected.', 'Beklenenden daha iyi']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "not as...as" = daha az: "not as big as" = daha küçük'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'This seat is _____ comfortable _____ that one.',
          options: ['as...as', 'more...than', 'so...as', 'the...than'],
          correct: 'as...as',
          explanation: 'Eşitlik: as + sıfat + as'
        },
        {
          type: 'fillInBlank',
          sentence: 'Economy is not _____ comfortable _____ business class.',
          answer: 'as, as',
          hint: 'not as + sıfat + as'
        },
        {
          type: 'multipleChoice',
          question: 'She works _____ hard _____ her colleagues.',
          options: ['as...as', 'more...than', 'so...than', 'the...as'],
          correct: 'as...as',
          explanation: 'Eşitlik: as + zarf + as'
        }
      ]
    }
  },
  'A2-U4-L5': {
    id: 'A2-U4-L5',
    title: 'Uygulama: Havayolu Karşılaştırması',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Havayollarını Karşılaştırma',
          explanation: 'Farklı havayollarını karşılaştırırken:',
          table: {
            headers: ['Özellik', 'Karşılaştırma'],
            rows: [
              ['Fiyat', 'Turkish Airlines is cheaper than Emirates.'],
              ['Hizmet', 'Qatar Airways has the best service.'],
              ['Filo', 'Emirates has more aircraft than Turkish Airlines.'],
              ['Konfor', 'Business class is more comfortable than economy.'],
              ['Güvenlik', 'Both airlines are equally safe.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta "Why our airline?" sorusuna karşılaştırma kullanarak cevap verin!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Karşılaştırma Kelimeleri',
          words: [
            { en: 'quality', tr: 'kalite', pronunciation: '/ˈkwɒləti/' },
            { en: 'standard', tr: 'standart', pronunciation: '/ˈstændəd/' },
            { en: 'reputation', tr: 'itibar', pronunciation: '/ˌrepjʊˈteɪʃn/' },
            { en: 'fleet', tr: 'filo', pronunciation: '/fliːt/' },
            { en: 'network', tr: 'ağ', pronunciation: '/ˈnetwɜːk/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillInBlank',
          sentence: 'Your airline has _____ (good) reputation in the industry.',
          answer: 'the best',
          hint: 'Superlative: the best'
        },
        {
          type: 'fillInBlank',
          sentence: 'Turkish Airlines is _____ (large) than many European carriers.',
          answer: 'larger',
          hint: 'Comparative: larger'
        },
        {
          type: 'speaking',
          instruction: 'Havayollarını karşılaştırın:',
          phrases: [
            '... is bigger/better/faster than ...',
            '... is the best/biggest/safest ...',
            '... is as good as ...',
            '... has more/fewer ... than ...'
          ]
        }
      ]
    }
  },
  'A2-U4-EXAM': {
    id: 'A2-U4-EXAM',
    title: 'Ünite 4 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'This aircraft is _____ than that one. (big)',
        options: ['bigger', 'more big', 'biger', 'biggest'],
        correct: 'bigger',
        explanation: 'Kısa sıfat + çift ünsüz + er'
      },
      {
        type: 'multipleChoice',
        question: 'Business class is _____ than economy. (comfortable)',
        options: ['more comfortable', 'comfortabler', 'most comfortable', 'comfortable'],
        correct: 'more comfortable',
        explanation: 'Uzun sıfat: more + sıfat'
      },
      {
        type: 'multipleChoice',
        question: 'This is _____ airport in Europe. (busy)',
        options: ['the busiest', 'busier', 'the most busy', 'busiest'],
        correct: 'the busiest',
        explanation: 'Superlative: the + sıfat + est'
      },
      {
        type: 'multipleChoice',
        question: 'This airline is _____ than that one. (good)',
        options: ['better', 'gooder', 'more good', 'best'],
        correct: 'better',
        explanation: 'good → better (düzensiz)'
      },
      {
        type: 'fillInBlank',
        sentence: 'This is _____ (bad) delay we have had.',
        answer: 'the worst',
        hint: 'bad → worst (superlative)'
      },
      {
        type: 'fillInBlank',
        sentence: 'Economy is not _____ comfortable _____ business.',
        answer: 'as, as',
        hint: 'Eşitlik: not as...as'
      },
      {
        type: 'matchPairs',
        instruction: 'Sıfatları formlarıyla eşleştirin',
        pairs: [
          { left: 'good', right: 'better - best' },
          { left: 'bad', right: 'worse - worst' },
          { left: 'fast', right: 'faster - fastest' },
          { left: 'comfortable', right: 'more comfortable - most comfortable' }
        ]
      }
    ]
  }
};

export default A2_UNIT_4;
